import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "popup-container" }
const _hoisted_2 = { class: "deposit-withdraw-page" }
const _hoisted_3 = { class: "tab-header" }
const _hoisted_4 = { class: "tab-content" }

import { ref, inject } from 'vue'
import depositView from '../deposit/depositView.vue'
import WithdrawView from '../withdraw/withdrawView.vue'
import CustomHeader from '@/themes/themeTwo/components/common/customHeader.vue'
import { useRoute, useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'

export default /*@__PURE__*/_defineComponent({
  __name: 'carteiraView',
  emits: ['handleClose', 'resetDepositData', 'reopenBackgroundRechargePopup'],
  setup(__props, { expose: __expose, emit: __emit }) {

const router = useRouter()
const route = useRoute()
const userStore = useUserStore()
const showPopup = ref(false)
const activeTab = ref(0)
const routeValue = ref(route.query.value)
const depositRef = ref()
const emits = __emit
const openPopup = (val: any) => {
  activeTab.value = val
  showPopup.value = true
  depositRef.value?.resetData()
}
const closePopup = () => {
  showPopup.value = false
  userStore.setRechargeBonusType(0)
  if (routeValue.value) {
    router.replace({ path: '/sdbigdep', query: {} })
  } else if (userStore.takeFirstDeposit) {
    router.replace({ path: '/firstDeposit', query: {} })
  }else if (userStore.firstRechargeAmount) {
    userStore.setFirstRechargeAmount('')
    router.replace({ path: '/firstRecharge', query: {} })
  } else {
    router.replace({ path: '/home', query: {} })
  }
  emits('handleClose')
  userStore.setTakeFirstDeposit(false)
  if (userStore.pendingBackendRecharge?.id) {
    emits('reopenBackgroundRechargePopup')
  }
}
const goToFund = () => {
  router.replace({ path: '/fundsHistory', query: {tabIndex : activeTab.value} })
}

__expose({ openPopup, closePopup })

return (_ctx: any,_cache: any) => {
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: showPopup.value,
    "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((showPopup).value = $event)),
    position: "bottom",
    round: "",
    style: {
    background: '#221b24',
    zIndex: '1998',
    minWidth: '100%',
    minHeight: '100%',
  }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(CustomHeader, {
          text: _ctx.$t('common.carteira'),
          "is-popup-close-back-icon": true,
          onClosePopup: closePopup,
          "show-fund": true,
          onGoToFund: goToFund
        }, null, 8, ["text"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass(["tab-item", { active: activeTab.value === 0 }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = 0))
            }, _toDisplayString(_ctx.$t('common.deposite')), 3),
            _createElementVNode("div", {
              class: _normalizeClass(["tab-item", { active: activeTab.value === 1 }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 1))
            }, _toDisplayString(_ctx.$t('common.sake')), 3)
          ]),
          _createElementVNode("div", _hoisted_4, [
            (activeTab.value === 0)
              ? (_openBlock(), _createBlock(depositView, {
                  key: 0,
                  ref_key: "depositRef",
                  ref: depositRef
                }, null, 512))
              : _createCommentVNode("", true),
            (activeTab.value === 1)
              ? (_openBlock(), _createBlock(WithdrawView, { key: 1 }))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})